import get from "lodash.get";

/**
 * Helpers shared by every antd column search dropdown (getColumnSearchProps).
 *
 * All of these tables filter on the SERVER: Table.onChange sends the entered
 * value to the API and the API returns the matching rows. The local onFilter
 * therefore runs a second time on top of those rows, and when its path does
 * not resolve on the record it used to drop every row - so a value that really
 * exists showed up as "No data".
 */

/** Read a column value. Accepts "email", "users.email" and ["users","email"]. */
export const getSearchValue = (record, dataIndex) => {
	if (dataIndex === undefined || dataIndex === null) return undefined;
	return get(record, Array.isArray(dataIndex) ? dataIndex.join(".") : dataIndex);
};

/**
 * Local filter to pair with a server-side column search.
 * If the value cannot be resolved on the record (mismatched or nested
 * dataIndex) the row is KEPT, so the client can never hide a row the server
 * already matched.
 */
export const columnSearchFilter = (dataIndex) => (value, record) => {
	const fieldValue = getSearchValue(record, dataIndex);
	if (fieldValue === undefined || fieldValue === null || fieldValue === "") return true;

	return fieldValue.toString().toLowerCase().includes(String(value ?? "").toLowerCase());
};

/** "users.phone_number" -> "Phone Number" (used for the dropdown placeholder). */
export const searchPlaceholder = (dataIndex) => {
	const path = Array.isArray(dataIndex) ? dataIndex : String(dataIndex ?? "").split(".");
	const field = path[path.length - 1] || "";

	return field
		.replace(/[_-]+/g, " ")
		.replace(/([a-z0-9])([A-Z])/g, "$1 $2")
		.replace(/\s+/g, " ")
		.trim()
		.replace(/\b\w/g, (c) => c.toUpperCase());
};
